import { useMemo } from 'react'

import { TimeArc } from './TimeArc'

interface Props {
  selectedStartTime: Date
  selectedEndTime: Date
  bookedIntervals: Array<{
    start: Date
    end: Date
    isConflicting?: boolean
  }>
}

export const TimeWheel = ({
  selectedStartTime,
  selectedEndTime,
  bookedIntervals,
}: Props) => {
  const { conflicting, nonConflicting } = useMemo(() => {
    return {
      conflicting: bookedIntervals.filter((interval) => interval.isConflicting),
      nonConflicting: bookedIntervals.filter(
        (interval) => !interval.isConflicting,
      ),
    }
  }, [bookedIntervals])

  return (
    <div className="relative mx-auto aspect-square w-full max-w-[220px]">
      <svg
        viewBox="0 0 220 200"
        className="h-full w-full rotate-0 transform"
      >
        <g transform="translate(10 0)">
          <circle
            cx="100"
            cy="100"
            r="100"
            className="fill-gray-900 stroke-gray-800"
            strokeWidth="1"
          />

          {[...Array(24)].map((_, i) => (
            <line
              key={i}
              x1="100"
              y1="0"
              x2="100"
              y2="8"
              className="stroke-gray-600"
              strokeWidth="0.5"
              transform={`rotate(${i * 15 + 180} 100 100)`}
            />
          ))}

          {nonConflicting.map((interval, index) => (
            <TimeArc
              key={`${interval.start}-${interval.end}`}
              startTime={interval.start}
              endTime={interval.end}
              isConflicting={interval.isConflicting}
            />
          ))}

          <TimeArc
            startTime={selectedStartTime}
            endTime={selectedEndTime}
            isSelected={true}
          />

          {conflicting.map((interval, index) => (
            <TimeArc
              key={`${interval.start}-${interval.end}`}
              startTime={interval.start}
              endTime={interval.end}
              isConflicting={interval.isConflicting}
            />
          ))}

          <g className="fill-gray-400 text-[10px]">
            <text
              x="100"
              y="35"
              textAnchor="middle"
            >
              12 AM
            </text>
            <text
              x="165"
              y="100"
              textAnchor="start"
            >
              3 AM
            </text>
            <text
              x="100"
              y="170"
              textAnchor="middle"
            >
              12 PM
            </text>
            <text
              x="35"
              y="100"
              textAnchor="end"
            >
              9 PM
            </text>
          </g>
        </g>
      </svg>
    </div>
  )
}
